export enum FeatureFlagEnum {
  AdminPanelV2 = 'admin-panel-v2',
  chargesWithCheckout = 'charges-with-checkout',
  ManualCreditNote = 'manual-credit-note',
  PartialPaymentPermission = 'partial-payment-permission',
  ResetAccountPermission = 'reset-account-permission',
  ActivateSubscriptionZatcaDeprecated = 'activate-subscription-zatca',
  InvoiceAndCreditNotesListing = 'invoice-and-credit-notes-listing',
  SubscriptionBackDate = 'subscription-back-date',
  AdminPanelPasswordlessAccountCreation = 'admin-panel-passwordless-account-creation',
  RewaapayGeideaAdmin = 'rp-pg-admin',
  DynamicMonshaatPlans = 'dynamic_monshaat_plans',
  GrubtechAddon = 'grubtech-addon',
  FbBundleAddon = 'fnb-bundle-addon',
  MonshaatAutoGeidea = 'monshaat-auto-geidea',
  HardwareReplacement = 'hardware-replacement',
  ClusterFreeHardware = 'cluster-free-hardware',
  ReactivateTrial = 'reactivate-trial',
  DepartmentCouponBudget = 'department-coupon-budget',
  UsersRoleAdminPanel = 'users-role-admin-panel',
  CouponListAdminPanel = 'coupon-list-admin-panel',
  AdminPanelAccountWallet = 'admin-panel-account-wallet',
  MonshaatBlockedOrders = 'admin-panel-monshaat-blocked-orders',
  AdminPortalManagement = 'FF_ADMIN_PORTAL_MANAGEMENT',
}
